import { DeleteButton as DeleteButtonBase, useNotify, useRecordContext } from 'react-admin'

import LockedForUpdateIcon from '../../components/icons/LockedForUpdateIcon'
import { SYSTEM_PERMISSION_UPDATE } from '../../config/permissions'
import { useIsFieldPermissionDenied } from '../../domain/permissions'

export const DeleteButton = ({ condition, confirmTitle, successMessage }) => {
  const record = useRecordContext()
  const notify = useNotify()
  const canNotEditLockedResource = useIsFieldPermissionDenied({
    action: SYSTEM_PERMISSION_UPDATE,
    source: 'locked_for_update',
  })
  const onSuccess = () => notify(successMessage, { type: 'info' })
  if (!record || (typeof condition === 'function' && !condition(record))) {
    return null
  }

  return canNotEditLockedResource && record.locked_for_update === true ? (
    <LockedForUpdateIcon />
  ) : (
    <DeleteButtonBase
      confirmColor="warning"
      confirmTitle={confirmTitle}
      mutationMode="optimistic"
      mutationOptions={{ onSuccess }}
    />
  )
}
